export const formatNumberHelper = (number: number, minimumFractionDigits = 0): string => {
  return new Intl.NumberFormat('ru', {
    minimumFractionDigits,
  }).format(number);
};
